import React, { useEffect, useState } from "react";
import {
  Checkbox,
  TextField,
  Typography,
  Autocomplete
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useDispatch } from "react-redux";
import { getDocumentTypeData } from "../../../../store/actions/documentAction";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function DocumentTypeFilter({ onChange,disabled }) {
  const dispatch = useDispatch();
  const [types, setTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  useEffect(() => {
    dispatch(getDocumentTypeData()).then(res => {
      setTypes(res?.data || []);
    });
  }, [dispatch]);

  const handleChange = (event, value) => {
    setSelectedTypes(value);

    // send only document_type_code array to parent
    const codes = value.map(item => item.document_type_code);
    onChange(codes);
  };

  return (
    <>
      <Typography variant="subtitle2" gutterBottom>
        Document Type
      </Typography>

      <Autocomplete
        multiple
        options={types}
        value={selectedTypes}
        disableCloseOnSelect
        disabled={disabled}
        getOptionLabel={(option) => option.abbrevation || ""}
        onChange={handleChange}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
                disabled={disabled}
              />
              {option.abbrevation}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            placeholder="Select document types"
            disabled={disabled}
          />
        )}
      />
    </>
  );
}
